export default __webpack_public_path__ + "static/media/icon-activity-search.bb7a9759.svg";